// extracted by mini-css-extract-plugin
export default {"cls1":"PaymentChannelView-EditButton_cls1__p6n15","cls2":"PaymentChannelView-EditButton_cls2__lzLi7 PaymentChannelView-EditButton_cls1__p6n15"};